import { invert } from 'remeda';

export const roles = {
  seeker: 'seeker',
  expert: 'expert',
  partner: 'partner',
} as const;

export const onboardingTypes = {
  individual: 'individual',
  business: 'business',
} as const;

export const licenseTypes = {
  driverLicense: 'driver_license',
  passport: 'passport',
  identityCard: 'identity_card',
} as const;

export const partnerPriceUnits = {
  per_month: 'per_month',
  per_week: 'per_week',
  per_day: 'per_day',
  per_hour: 'per_hour',
  fixed_price: 'fixed_price',
} as const;

export const expertPriceUnits = {
  individual: {
    fixedPrice: 'fixed_price',
    negotiable: 'negotiable',
  },
  business: {
    hourlyRate: 'hourly_rate',
    fixedPrice: 'fixed_price',
    packages: 'packages',
  },
} as const;

export const serviceLocations = {
  remote: 'remote',
  specificLocation: 'specific_location',
} as const;

export const hiringTypes = {
  perDuration: 'per_duration',
  perCampaign: 'per_campaign',
  perSocialMediaPost: 'per_social_media_post',
} as const;

export const adSpaceHiringTypes = {
  perDay: 'per_day',
  perHour: 'per_hour',
  perWeek: 'per_week',
  perMonth: 'per_month',
  fixedPrice: 'fixed_price',
} as const;

export const adSpacePricingUnits = {
  perDay: 'per_day',
  perWeek: 'per_week',
  perHour: 'per_hour',
  perMonth: 'per_month',
  fixedPrice: 'fixed_price',
} as const;

export const adSpacePricingTypeLabels = {
  post: 'Per Social Media Post',
  campaign: 'Per Campaign',
  duration: 'Per Duration',
} as const;

export const servicePricingUnits = {
  hourly: 'hourly',
  fullPackage: 'full_package',
  requestForQuote: 'quote_on_pricing',
} as const;

export enum BookingStatusEnum {
  BOOKED = 'booked',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  SEEKER_APPROVED = 'seeker_approved',
  SEEKER_RAISE_DISPUTED = 'seeker_raise_disputed',
}

export const statusMap = {
  [BookingStatusEnum.BOOKED]: {
    text: 'Booked',
    className: 'bg-green-100 text-green-700 border-green-300',
  },
  [BookingStatusEnum.APPROVED]: {
    text: 'Approved',
    className: 'bg-blue-100 text-blue-700 border-blue-300',
  },
  [BookingStatusEnum.REJECTED]: {
    text: 'Rejected',
    className: 'bg-red-100 text-red-700 border-red-300',
  },
  [BookingStatusEnum.COMPLETED]: {
    text: 'Completed',
    className: 'bg-gray-100 text-gray-700 border-gray-300',
  },
  [BookingStatusEnum.CANCELED]: {
    text: 'Canceled',
    className: 'bg-red-100 text-red-700 border-red-300',
  },
  [BookingStatusEnum.SEEKER_APPROVED]: {
    text: 'Seeker Approved',
    className: 'bg-indigo-100 text-indigo-700 border-indigo-300',
  },
  [BookingStatusEnum.SEEKER_RAISE_DISPUTED]: {
    text: 'Disputed',
    className: 'bg-orange-100 text-orange-700 border-orange-300',
  },
} as const;

export enum Environment {
  LOCAL = 'local',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export type BookingStatus = keyof typeof statusMap;

export const invertedServicePricingUnits = invert(servicePricingUnits);
